import { useContext } from 'react';
import { InventoryEditProductFormContext } from '../../../Context/InventoryEditProductFormContext';
import Input from '../../../Components/Input/Input';

function PackagingDetails() {
    const { packagingDetails, setPackagingDetails, formErrors } = useContext(InventoryEditProductFormContext);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPackagingDetails({ ...packagingDetails, [name]: value });
    }

    return (
        <div className="flex flex-col gap-4 border border-[#EAEAEA] p-5 rounded-xl">
            <h1 className='font-semibold text-[18px] leading-[26px]'>Packaging Details</h1>

            <div className="grid grid-cols-2 gap-x-2 gap-y-4">
                <Input 
                    labelText='Width in cm' 
                    errorText={formErrors.width} 
                    inputOptions={{
                        type: 'number',
                        id: 'width',
                        name: 'width',
                        placeholder: 'enter width',
                        value: packagingDetails.width,
                        onChange: handleChange
                    }}
                    required
                />
                
                <Input 
                    labelText='Height in cm' 
                    errorText={formErrors.height} 
                    inputOptions={{
                        type: 'number',
                        id: 'height',
                        name: 'height',
                        placeholder: 'enter height',
                        value: packagingDetails.height,
                        onChange: handleChange
                    }}
                    required
                />

                <Input 
                    labelText='Weight in gms' 
                    errorText={formErrors.weight} 
                    inputOptions={{
                        type: 'number',
                        id: 'weight',
                        name: 'weight',
                        placeholder: 'enter weight',
                        value: packagingDetails.weight,
                        onChange: handleChange
                    }}
                    required
                />
            </div>
        </div>
    );
}

export default PackagingDetails;
